import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import TableDelBtn from "../../../component/atoms/button/tableDelBtn";
import Checkbox from "../../../component/atoms/input/checkbox";
import SearchBar from "../../../component/atoms/input/searchBar";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Table from "../../../component/atoms/layout/table/table";
import TableLayout from "../../../component/atoms/layout/table/tableLayout";
import TableSearchBtn from "../../../component/atoms/layout/table/tableSearchBtn";
import TableTop from "../../../component/atoms/layout/table/tableTop";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import TableText from "../../../component/atoms/text/table/tableText";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import Pagination from "../../../component/molecules/pagination";
import TableCount from "../../../component/molecules/tableCount";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { route } from "../../../router/route";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import MemberApi from "../../../api/memebr.api";
import ExcelBtn from "../../../component/atoms/button/excelBtn";
import { saveAs } from "file-saver";
import ExcelApi from "../../../api/excel.api";

const LeaveMember = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [keyword, setKeyword] = useState("");

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  // ----------------------------------- //
  // ---------- 마운트가 되면 ---------- //
  // --------------------------------- //
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    getLeaveMemberList();
  }, [location]);

  const [leaveMemberList, setLeaveMemberList] = useState([]);

  const getLeaveMemberList = async () => {
    try {
      const data = {
        keyword: searchParams.get("keyword"),
        page: searchParams.get("page"),
        size: pagination.size,
      };
      let response = (await MemberApi.getCancelList(data)).data.data;

      setLeaveMemberList(
        response.content.map((item) => {
          return {
            ...item,
            checked: false,
          };
        })
      );

      setPagination({
        ...pagination,
        totalCount: response.totalCount ? response.totalCount : 0,
        totalPages: Math.ceil(response.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const isAllCheck = useMemo(() => {
    const checkedList = leaveMemberList.filter((item) => item.checked);
    return (
      checkedList.length !== 0 && checkedList.length === leaveMemberList.length
    );
  }, [leaveMemberList]);

  const [title, setTitle] = useState(`탈퇴 회원 관리`);
  const [subTitle, setSubTitle] = useState(`이용자`);

  // ----- 삭제
  const [delIdList, setDelIdList] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: delIdList,
      };
      await MemberApi.deleteCancelMember(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      setDelIdList([]);
      getLeaveMemberList();
    } catch (error) {
      errorHandler(error);
    }
  };

  //------------엑셀 생성
  const downloadExcel = async (excelData) => {
    const Excel = require("exceljs");
    const workbook = new Excel.Workbook();
    workbook.addWorksheet("Sheet One");
    const sheetOne = workbook.getWorksheet("Sheet One");

    sheetOne.columns = [
      { header: "아이디", key: "account", width: 40 },
      { header: "이름", key: "name", width: 40 },
      { header: "탈퇴사유", key: "reason", width: 60 },
      { header: "탈퇴일", key: "createdAt", width: 20 },
    ];

    excelData.map((item) => {
      // 행 추가
      sheetOne.addRow(item);
    });
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "탈퇴 회원 관리.xlsx");
  };

  const getExcelAll = async () => {
    try {
      const excelArr = [];
      const response = (
        await ExcelApi.GetRetiredMemberExcel({
          ids: [],
          allFlag: true,
        })
      ).data.data.content;

      response.forEach((item) => {
        excelArr.unshift({
          ...item,
          createdAt: moment(item.createdAt).format("YYYY/MM/DD"),
        });
      });

      downloadExcel(excelArr);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getExcelChecked = async () => {
    const filter = leaveMemberList.filter((item) => item.checked);
    if (filter.length <= 0) {
      return toast("항목을 선택해주세요");
    }

    try {
      const excelArr = [];
      const response = (
        await ExcelApi.GetRetiredMemberExcel({
          ids: filter.map((item) => item.id),
          allFlag: false,
        })
      ).data.data.content;

      response.forEach((item) => {
        excelArr.unshift({
          ...item,
          createdAt: moment(item.createdAt).format("YYYY/MM/DD"),
        });
      });

      downloadExcel(excelArr);
    } catch (error) {
      errorHandler(error);
    }
  };
  //------------액셀 부분 끝

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <TableTitle>{title}</TableTitle>
          <TableTop>
            <TableCount text={subTitle} count={pagination.totalCount} />
            <TableSearchBtn>
              <SearchBar
                placeholder={"검색어를 입력하세요."}
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(
                      `${route.user_leave_member}?page=1&keyword=${encodeURIComponent(keyword.trim())}`,
                      {
                        replace: true,
                      }
                    );
                  }
                }}
                onClick={() => {
                  navigate(
                    `${route.user_leave_member}?page=1&keyword=${encodeURIComponent(keyword.trim())}`,
                    {
                      replace: true,
                    }
                  );
                }}
              />
              <ExcelBtn
                onSelectClick={getExcelChecked}
                onAllClick={getExcelAll}
              />
            </TableSearchBtn>
          </TableTop>
          <Table>
            <colgroup>
              {/* 체크박스 영역 */}
              <col width={"90px"} />
              {/* 아이디 */}
              <col width={"241px"} />
              {/* 이름 */}
              <col width={"156px"} />
              {/* 탈퇴사유 */}
              <col width={"340px"} />
              {/* 탈퇴일 */}
              <col width={"144px"} />
              {/* 완전 삭제 */}
              <col width={"73px"} />
            </colgroup>
            <thead>
              <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setLeaveMemberList(
                          leaveMemberList.map((item) => {
                            return {
                              ...item,
                              checked: true,
                            };
                          })
                        );
                      } else {
                        setLeaveMemberList(
                          leaveMemberList.map((item) => {
                            return {
                              ...item,
                              checked: false,
                            };
                          })
                        );
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText>{"아이디"}</TableText>
                </Th>
                <Th>
                  <TableText>{"이름"}</TableText>
                </Th>
                <Th>
                  <TableText>{"탈퇴사유"}</TableText>
                </Th>
                <Th>
                  <TableText>{"탈퇴일"}</TableText>
                </Th>
                <Th>
                  <TableText>{"완전 삭제"}</TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {leaveMemberList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{ height: "59px", background: "#fff" }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={item.checked}
                        onChange={() => {
                          item.checked = !item.checked;
                          setLeaveMemberList([...leaveMemberList]);
                        }}
                      />
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          width: "210px",
                        }}
                      >
                        {item.account}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>{item.name}</TableText>
                    </Td>
                    <Td>
                      <TableText>{item.reason}</TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.createdAt).format("YYYY/MM/DD")}
                      </TableText>
                    </Td>
                    <Td>
                      <TableDelBtn
                        style={{ marginLeft: "6px" }}
                        onClick={() => {
                          setLeaveMemberList([...leaveMemberList]);
                          const delList = [item];
                          setDelIdList(delList.map((item) => item.id));
                          setDeleteModalOpen(true);
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <Pagination
            route={route.user_leave_member}
            queryString={`keyword=${encodeURIComponent(searchParams.get("keyword") || "")}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
          />
        </TableLayout>
      </MainLayout>

      {deleteModalOpen ? (
        <Modal
          negative={true}
          title={modalMsg.delete.title}
          text={modalMsg.delete.content}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default LeaveMember;
